import { Phone, MessageSquare, MapPin, Shield } from "lucide-react";
import { BRAND } from "../lib/constants";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="border-t border-zinc-900 bg-black relative"
    >
      {/* Big phone CTA strip */}
      <div className="border-b border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-7">
            <div className="text-[10px] tracking-[0.3em] text-[#E50914] uppercase mb-3">
              ⏤ Book Now · Limited Availability
            </div>
            <div className="font-display text-4xl md:text-6xl uppercase tracking-tighter leading-none">
              Call or text — <br />
              <a
                href={BRAND.phoneLink}
                className="text-[#E50914] hover:underline"
                data-testid="footer-phone-large"
              >
                {BRAND.phone}
              </a>
            </div>
          </div>
          <div className="md:col-span-5 flex flex-col sm:flex-row gap-3">
            <a
              href={BRAND.phoneLink}
              data-testid="footer-call-btn"
              className="flex-1 bg-[#E50914] hover:bg-[#FF2A2A] text-white px-6 py-5 text-sm font-bold uppercase tracking-[0.25em] inline-flex items-center justify-center gap-3 transition-all hover:shadow-[0_0_24px_rgba(229,9,20,0.5)]"
            >
              <Phone className="w-4 h-4" /> Call
            </a>
            <a
              href={BRAND.smsLink}
              data-testid="footer-text-btn"
              className="flex-1 border border-zinc-700 text-white px-6 py-5 text-sm font-bold uppercase tracking-[0.25em] inline-flex items-center justify-center gap-3 hover:bg-white hover:text-black transition-all"
            >
              <MessageSquare className="w-4 h-4" /> Text
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="SFE" className="h-12 w-12 object-contain" />
            <div>
              <div className="font-display text-lg leading-none tracking-tight">SFE BLACK CAR</div>
              <div className="text-[10px] tracking-[0.3em] text-zinc-500 mt-1">
                LUXURY · <span className="text-[#E50914]">SAFETY</span> · EXPERIENCE
              </div>
            </div>
          </div>
          <p className="mt-6 text-sm text-zinc-500 leading-relaxed max-w-md">
            Atlanta's premium black car service. Cadillac Escalade, 2026 Sprinter Van, and
            White Rolls Royce. Professional chauffeurs. Available 24/7 for weddings, proms,
            corporate, airport and VIP transport.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase mb-5">Service</div>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-[#E50914]" /> Atlanta, GA & Surrounding
            </li>
            <li className="flex items-center gap-3">
              <Shield className="w-4 h-4 text-[#E50914]" /> Licensed · Insured
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#E50914]" />
              <a href={BRAND.phoneLink} className="hover:text-white">
                {BRAND.phone}
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase mb-5">
            Quick Links
          </div>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li><a href="#fleet" className="hover:text-white">Our Fleet</a></li>
            <li><a href="#packages" className="hover:text-white">Wedding & Prom Packages</a></li>
            <li><a href="#addons" className="hover:text-white">VIP Add-Ons</a></li>
            <li><a href="#book" className="hover:text-white">Book Now</a></li>
            <li><a href="/admin/login" className="hover:text-white text-zinc-600" data-testid="footer-admin-link">Admin</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-wrap items-center justify-between gap-3 text-[10px] tracking-[0.25em] uppercase text-zinc-600">
          <div>© {new Date().getFullYear()} SFE Black Car · All Rights Reserved</div>
          <div>Pricing includes professional chauffeur. Fuel, tolls & gratuity not included.</div>
        </div>
      </div>
    </footer>
  );
};
